<button
  class="btn"
  [class]="[iconType, frameShape].join(' ')"
  [class.hasFrame]="hasFrame"
  frameShape="square"
  [style.width]="size + 'px'"
  [style.height]="size + 'px'"
  [disabled]="disabled"
  [ngClass]="color"
  (click)="handleClick($event)"
>
  @if (iconType === 'image') {
    <img class="icon" [src]="icon" alt="Icon" />
  } @else {
    <i class="icon" [class]="icon" [style.fontSize]="iconFontSize + 'px'"></i>
  }
</button>
